import { gql } from "@apollo/client";

export const PROJECTS = gql`
  query Projects(
    $where: ProjectWhereInput
    $like: JSONObject
    $isIn: JSONObject
    $take: Int
    $skip: Int
  ) {
    projects(
      where: $where
      like: $like
      isIn: $isIn
      take: $take
      skip: $skip
    ) {
      data {
        id
        name
        createdDate
        locked
        ria
        tracer {
          name
        }
        contract {
          issuanceDate
        }
        statuses {
          id
          createdDate
          status {
            id
            template
            name
            tag
            progress
            order
            color
            background
            createdDate
            actions {
              id
              type
              args
              conditions {
                id
                operation
                rightOperand
                leftOperand
              }
            }
            process {
              id
              type
              processStatuses {
                id
                name
                tag
                template
                progress
                order
              }
            }
          }
        }
        fields
        contact {
          id
          relatedPersons {
            id
            relationship
            authority
            identity {
              id
              socialSecurityNumber
              user {
                id
                firstname
                lastname
                birthDate
                gender
                birthName
              }
            }
          }

          user {
            firstname
            lastname
            gender
          }
        }
        author {
          id
          firstname
          lastname
        }
        subscriptions {
          id
          status
        }
        expired
      }
      count
    }
  }
`;

export const PROJECTS_LIST = gql`
  query ProjectsList(
    $where: ProjectWhereInput
    $exclude: [String]
    $withSubscriptions: Boolean!
    $withContract: Boolean!
    $withProcess: Boolean!
    $withTracers: Boolean!
    $withFlows: Boolean!
    $withProcessStatuses: Boolean!
    $like: JSONObject
    $isIn: JSONObject
    $take: Int
    $skip: Int
    $advancedFilters: [AdvancedFilterInput]
  ) {
    projectsList(
      where: $where
      exclude: $exclude
      like: $like
      isIn: $isIn
      take: $take
      skip: $skip
      advancedFilters: $advancedFilters
    ) {
      data {
        id
        name
        createdDate
        locked
        ria
        tracer {
          name
        }
        contract @include(if: $withContract) {
          issuanceDate
        }
        statuses {
          id
          createdDate
          status {
            id
            template
            name
            tag
            progress
            order
            color
            background
            createdDate
            process @include(if: $withProcess) {
              id
              type
              flows @include(if: $withFlows) {
                id
                tracers @include(if: $withTracers) {
                  id
                }
              }
              processStatuses @include(if: $withProcessStatuses) {
                id
                name
                tag
                template
                progress
                order
                possibleStatuses @include(if: false) {
                  id
                  nextStatus
                  conditions @include(if: false) {
                    id
                    operation
                    rightOperand
                    leftOperand
                  }
                }
                actions @include(if: false) {
                  id
                  type
                  args
                  conditions @include(if: false) {
                    id
                    operation
                    rightOperand
                    leftOperand
                  }
                }
              }
            }
          }
        }
        fields
        contact {
          id
          user {
            firstname
            lastname
            gender
          }
        }
        author {
          id
          firstname
          lastname
        }
        subscriptions @include(if: $withSubscriptions) {
          id
          status
        }
        expired
      }
      count
    }
  }
`;

export const PROJECT = gql`
  query Project($where: ProjectWhereInput) {
    project(where: $where) {
      id
      externalId
      name
      ria
      tracer {
        name
      }
      campaign {
        id
      }
      terminationRequest {
        id
        contractNumber
        reason
        recipient
        dueDate
        address
        brokerageMandate {
          id
          firstName
          lastName
          currentCompany
        }
      }
      statuses {
        id
        createdDate
        status {
          id
          template
          name
          tag
          progress
          order
          color
          background
          moveToNext
          createdDate
          possibleStatuses {
            order
            nextStatus
            conditions {
              operation
              rightOperand
              leftOperand
            }
          }
          actions {
            id
            type
            args
            conditions {
              id
              operation
              rightOperand
              leftOperand
            }
          }
          process {
            id
            theme
            type
            processStatuses {
              id
              name
              tag
              template
              progress
              order
              color
              background
              moveToNext
              possibleStatuses {
                id
                nextStatus
                conditions {
                  id
                  operation
                  rightOperand
                  leftOperand
                }
              }
              actions {
                id
                type
                args
                conditions {
                  id
                  operation
                  rightOperand
                  leftOperand
                }
              }
            }
          }
        }
      }
      fields
      contact {
        id
        profession
        socialRegime
        socioProfessionalCategory
        socialSecurityNumber
        exerciseFrame
        acceptContact
        acceptContactDate
        acceptDigital
        optMadelin
        telecoms {
          id
          system
          value
        }
        user {
          id
          firstname
          lastname
          gender
          phone
          birthDate
        }
        relatedPersons {
          id
          relationship
          authority
          identity {
            id
            socialRegime
            socioProfessionalCategory
            socialSecurityNumber
            user {
              id
              gender
              firstname
              lastname
              birthDate
            }
          }
        }
        telecoms {
          id
          system
          value
        }
        fields
      }
      contract {
        id
        issuanceDate
      }
      locked
      expired
      subscriptions {
        id
        status
        insurancePlan {
          id
          config
        }
      }
      author {
        id
        firstname
        lastname
        email
        phone
        address
        zipCode
        city
      }
    }
  }
`;

export const PROJECT_ELIGIBILITY = gql`
  query ProjectEligibility($raw: [String]) {
    projectEligibility(raw: $raw) {
      status
      eligibleDate
      author {
        id
        firstname
        lastname
      }
    }
  }
`;

export const SEARCH_PROJECT_GRA = gql`
  query SearchProjectGRA(
    $where: ProjectWhereInput
    $data: SearchProjectGRAInput
  ) {
    searchProjectGRA(where: $where, data: $data) {
      lastName
      firstName
      graCode
      status
    }
  }
`;

const projects = {
  PROJECTS,
  PROJECTS_LIST,
  PROJECT,
  PROJECT_ELIGIBILITY,
  SEARCH_PROJECT_GRA,
};

export default projects;
